import clsx from 'clsx';

import styles from './InputLabel.module.css';

import type { InputLabelProps } from './InputLabel.types';

function InputLabel({ className, children, isRequired, variant = 'regular', ...props }: InputLabelProps) {
  return (
    <label {...props} className={clsx(styles.label, styles[variant], className)}>
      {isRequired && (
        <span aria-hidden="true" className={styles.required} title="Required field">
          *
        </span>
      )}
      {children}
    </label>
  );
}

export default InputLabel;
